import { useNavigate } from "react-router-dom";
import { PlaygroundPageItem } from "../../constants";
import {
  Autocomplete,
  Box,
  Button,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import CircledBackButton from "@/features/Common/components/CircledBackButton";
import { convertPascalCaseToWords } from "@/utils";

function PlaygroundSearch({ pages }: { pages: PlaygroundPageItem[] }) {
  const navigate = useNavigate();

  const searchOptions = pages
    .toSorted((a, b) => (a.name > b.name ? 1 : -1))
    .map((page) => ({
      label: page.name,
    }));

  const onAutocompleteChange = (
    _event: React.ChangeEvent<any>,
    value: {
      label: string;
    } | null
  ) => {
    if (value) {
      navigate(`/playground/${value.label}`);
    }
  };

  return (
    <Autocomplete
      options={searchOptions}
      fullWidth
      renderInput={(params) => (
        <TextField
          {...params}
          label="Search page"
          placeholder="Type something"
          variant="outlined"
        />
      )}
      onChange={onAutocompleteChange}
    />
  );
}

export default function PlaygroundHeader({
  pageName,
  shouldShowBackButton = true,
  pages,
}: {
  pageName: string;
  shouldShowBackButton?: boolean;
  pages: PlaygroundPageItem[];
}) {
  const navigate = useNavigate();

  return (
    <Stack
      position="sticky"
      width="100%"
      top="0"
      zIndex="2"
      p={2}
      spacing={1}
      bgcolor="background.paper"
    >
      <Stack p={0} flex={0}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={2}
          p={1}
        >
          {shouldShowBackButton && (
            <CircledBackButton onClick={() => navigate("/playground")} />
          )}

          <Box flexGrow={1}>
            <Typography variant="h4" textAlign="center">
              {convertPascalCaseToWords(pageName)}
            </Typography>
          </Box>
        </Stack>
      </Stack>
      <Stack direction="row" justifyContent="space-between" spacing={2}>
        <Box flexGrow={1}>
          <PlaygroundSearch pages={pages} />
        </Box>
        <Button href="/">Exit Playground</Button>
      </Stack>
    </Stack>
  );
}
